import React from "react";
import { statusTone } from "@/lib/format";

const TONE_CLASSES = {
  match: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  error: "bg-red-50 text-red-700",
  info: "bg-blue-50 text-blue-700",
  neutral: "bg-slate-100 text-slate-700",
};

export const StatusBadge = ({ status, testId }) => {
  const tone = statusTone(status);
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${TONE_CLASSES[tone]}`}
    >
      {status || "—"}
    </span>
  );
};

export default StatusBadge;
